import { IcInfo } from '@assets/icons/40x40';
import { For, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { DraggablePanel } from '@components/ui/draggable';
import { RefObject } from 'react';
import { FormattedMessage } from 'react-intl';

import PopupContainer from './common/PopupContainer';

type Props = {
  mapConstraintsRef: RefObject<HTMLDivElement | null>;
  onClose: () => void;
};

export default function MeasureInfoPopup({ mapConstraintsRef, onClose }: Readonly<Props>) {
  return (
    <DraggablePanel.Root constraintsRef={mapConstraintsRef} top={200} left={850}>
      <DraggablePanel.Header onClose={onClose}>
        <FormattedMessage id="controls.toolMenu.measure.azimuthAndDistance.title" />
      </DraggablePanel.Header>
      <DraggablePanel.Body width={600}>
        <PopupContainer>
          <HStack width="100%" height="100%" gap={1} alignItems="start">
            <Icon as={IcInfo} boxSize={{ base: '24px', '4k': '32px' }} color="neutral.white" />
            <VStack width="100%" height="100%" gap={2} alignItems="start">
              <For each={[1, 2, 3]}>
                {(value) => (
                  <HStack width="100%" gap={1} alignItems="start">
                    <Text textStyle="screenStd">{`${value})`}</Text>
                    <Text textStyle="screenStd">
                      <FormattedMessage id={`controls.toolMenu.measure.azimuthAndDistance.instructions.${value}`} />
                    </Text>
                  </HStack>
                )}
              </For>
            </VStack>
          </HStack>
        </PopupContainer>
      </DraggablePanel.Body>
    </DraggablePanel.Root>
  );
}
